var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"search-bar",attrs:{"prepend-inner-icon":"mdi-magnify","placeholder":"Caută în tabel","aria-label":"Caută în tabel","outlined":"","dense":"","single-line":"","hide-details":"","clearable":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})
}
var staticRenderFns = []

export { render, staticRenderFns }